export const SITE = {
  name: "Concurso Astor",
  shortName: "Concurso Astor",
  tagline:
    "Conteúdo de qualidade e dicas práticas para empresas e empreendedores.",
  description:
    "Plataforma editorial independente com artigos, análises e dicas sobre gestão, estratégia, finanças, marketing, vendas e crescimento sustentável para empresas e empreendedores.",
  baseUrl: "https://concursoastor.com.br",
  email: "svgmultimidia@gmail.com",
  social: {
    instagram: "https://www.instagram.com/",
    linkedin: "https://www.linkedin.com/",
    facebook: "https://www.facebook.com/",
  },
};

export const NAV = [
  { to: "/", label: "Início" },
  { to: "/blog", label: "Artigos" },
  { to: "/sobre", label: "Sobre" },
  { to: "/equipe", label: "Time editorial" },
  { to: "/contato", label: "Contato" },
] as const;
